const layouts = [
  {
    type: 'oficial',
    model: [
      'floranny',
      'por-sol',
      'algas-marinhas',
      'conchas-oceano',
      'floral-night',
      'floral-rustico',
      'floral-clean',
      'floral-ellegance',
      'floral-maritimo',
      'classico',
      'rustico',
      'romantico',
      'moderno',
      'aquarela',
      'pintura',
    ],
  },
  {
    type: 'save-the-date',
    model: [
      'floranny',
      'por-sol',
      'algas-marinhas',
      'conchas-oceano',
      'floral-night',
      'floral-rustico',
      'floral-clean',
      'floral-ellegance',
      'floral-maritimo',
      'classico',
      'rustico',
      'romantico',
      'moderno',
      'aquarela',
      'pintura',
    ],
  },
  {
    type: 'comunicado',
    model: [
      'floranny',
      'por-sol',
      'algas-marinhas',
      'conchas-oceano',
      'floral-night',
      'floral-rustico',
      'floral-clean',
      'floral-ellegance',
      'floral-maritimo',
      'classico',
      'rustico',
      'romantico',
      'moderno',
      'aquarela',
      'pintura',
    ],
  },
]

module.exports = layouts
